import {
  IQuotePackage,
  IQuotePackageData,
  IQuotePackageDocument,
  IQuotePackageDocumentData
} from '../quote.types';
import { QuotePackage, QuotePackageDocument } from '../quote';
import { mockQuotesData } from './quote.mock';

export const mockQuotePackageDocumentsData = (): IQuotePackageDocumentData[] => [
  {
    id: 1,
    quote_document: {
      id: 2,
      document: {
        id: 2,
        title: 'ONGA BUNGA',
        description: '',
        created_at: '2024-09-25T17:46:56.176644Z',
        latest_revision: {
          id: 2,
          owner: 'LeRon Harris',
          revision: 1,
          uploaded_at: '2024-09-25T17:46:56.189402Z',
          file: 'http://127.0.0.1:8000/v1/documents/2/download-file/2/'
        },
        tags: []
      }
    }
  },
  {
    id: 2,
    quote_document: {
      id: 3,
      document: {
        id: 3,
        title: 'Guardian',
        description: '',
        created_at: '2024-09-25T17:47:06.832993Z',
        latest_revision: {
          id: 3,
          owner: 'LeRon Harris',
          revision: 1,
          uploaded_at: '2024-09-25T17:47:06.838803Z',
          file: 'http://127.0.0.1:8000/v1/documents/3/download-file/3/'
        },
        tags: []
      }
    }
  }
];

export const mockQuotePackageDocuments = (
  data: IQuotePackageDocumentData[] = mockQuotePackageDocumentsData()
): IQuotePackageDocument[] => data.map(item => new QuotePackageDocument(item));

export const mockQuotePackagesData = (): IQuotePackageData[] => [
  {
    id: 1,
    package_documents: mockQuotePackageDocumentsData(),
    quotes: mockQuotesData(),
    created_at: '2024-09-19T18:07:09.301821Z',
    updated_at: '2024-09-26T15:21:59.555487Z'
  },
  {
    id: 2,
    package_documents: mockQuotePackageDocumentsData(),
    quotes: mockQuotesData(),
    created_at: '2024-09-26T17:48:11.049912Z',
    updated_at: '2024-09-26T17:48:11.049985Z'
  },
  {
    id: 3,
    package_documents: mockQuotePackageDocumentsData(),
    quotes: mockQuotesData(),
    created_at: '2024-09-26T17:48:22.347502Z',
    updated_at: '2024-09-26T17:48:22.347567Z'
  },
  {
    id: 4,
    package_documents: mockQuotePackageDocumentsData(),
    quotes: mockQuotesData(),
    created_at: '2024-09-26T17:48:26.517230Z',
    updated_at: '2024-09-26T17:48:26.517290Z'
  },
  {
    id: 5,
    package_documents: [],
    quotes: [],
    created_at: '2024-09-26T17:48:30.395771Z',
    updated_at: '2024-09-26T17:48:30.395826Z'
  },
  {
    id: 6,
    package_documents: [],
    quotes: mockQuotesData(),
    created_at: '2024-09-26T17:48:34.251554Z',
    updated_at: '2024-09-26T17:48:34.251627Z'
  },
  {
    id: 7,
    package_documents: [],
    quotes: mockQuotesData(),
    created_at: '2024-09-26T17:48:44.175947Z',
    updated_at: '2024-09-26T17:48:44.176008Z'
  }
];

export const mockQuotePackages = (
  data: IQuotePackageData[] = mockQuotePackagesData()
): IQuotePackage[] => data.map(item => new QuotePackage(item));
